<template>
  <div class="grade-rule-container">
    <div class="grade-rule-card" dir="rtl" v-if="lang === 'ug'">
      <h2 class="title">يەتكۈزگۈچى دەرىجىسى</h2>
      <div class="desc">
        يەتكۈزگۈچى دەرىجىسى ۋە دەرىجە نومۇرى ھەر دۈشەنبە كۈنى يىڭىلىنىدۇ.
        يەتكۈزگۈچىلەرنىڭ ئەڭ كۆپ زاكاز توشۇش سانى ئالدىنقى كۈنلۈك زاكاز توشۇش
        ئىستاستىكىسىغا ئاساسەن بىكىتىلىدۇ، ھەر كۈنى ئەتتىگەن يېڭىلىنىدۇ
        (كىچىككەن، ئارقا سۇپىدىن باسمىلانغان زاكازلار ھىسابلانمايدۇ) رايۇنلارنىڭ
        زاكاز ۋە يەتكۈزگۈچى ئەھۋالىنىڭ ئوخشىماسلىقى سەۋەبى يەتكۈزگۈچىلەرنىڭ
        دەرىجىسى رايۇن بويىچە تەڭ نىسبەتتە بىردىن بەش يۇلتۇزغىچە بۆلۈنىلىدۇ.
        نومۇر ھىسابلاش قائىدىسى: ئالدىنقى بىر ھەپتىلىك (دۈشەنبىدىن يەكشەنبە
        كۈنىگىچە)يەتكۈزۈش ئۇچۇرى ھىسابلىنىدۇ. ئەڭ ئاخىرىدا ئومۇمىي نۇمۇر
        ھىسابلىنىپ، نۇمۇر بويىچە رەتكە تۇرغۇزىلىدۇ ۋە دەرىجىگە بۆلۈنىلىدۇ.
      </div>
      <table class="grade-table">
        <thead>
          <tr>
            <th>تۈرلەر</th>
            <th>تەپسىلاتى</th>
            <th>نومۇر</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ئاساسىي نومۇر</td>
            <td>ئاساسىي نومۇر</td>
            <td class="score plus">+100</td>
          </tr>
          <tr>
            <td rowspan="2">قوشۇلىدىغان نومۇر</td>
            <td>ۋاقتىدا يەتكۈزگەن</td>
            <td class="score plus">+0.2</td>
          </tr>
          <tr>
            <td>ياخشى ئىنكاس</td>
            <td class="score plus">+0.3</td>
          </tr>
          <tr>
            <td rowspan="6">تارتىلىدىغان نومۇر</td>
            <td>كېچىكىش ۋاقتى 0-5 مىنۇت</td>
            <td class="score minus">-1</td>
          </tr>
          <tr>
            <td>كېچىكىش ۋاقتى 5-10 مىنۇت</td>
            <td class="score minus">-2</td>
          </tr>
          <tr>
            <td>كېچىكىش ۋاقتى 10 مىنۇتتىن يۇقىرى</td>
            <td class="score minus">-3</td>
          </tr>
          <tr>
            <td>ئەرىز-شىكايەت</td>
            <td class="score minus">-3</td>
          </tr>
          <tr>
            <td>ناچار ئىنكاس</td>
            <td class="score minus">-1</td>
          </tr>
          <tr>
            <td>ئالدىن زاكازنى 20مىنۇت بالدۇر يەتكۈزۈش</td>
            <td class="score minus">-1</td>
          </tr>
        </tbody>
      </table>
      <div class="sub-title">دەرىجە بويىچە زاكاز تەقسىملەش قائىدىسى</div>
      <div class="desc">
        يەتكۈزگۈچىلەرنىڭ ئىشقا چىقىش يوقلىمىسىدىن ئۆتكەندىن تارتىپ زاكاز
        تەقسىملىگۈچە بولغان ئەمەلىي ئىشىقا چىقىش ۋاقتى خاتىرلىنىدۇ ۋە شۇ ۋاقت
        ئىچىدە يەتكۈزگەن زاكاز سانى خاتىرلىنىدۇ، بۇ ئارقىلىق يەتكۈزگۈچىنىڭ زاكاز
        يەتكۈزۈش ئۈنىمى ھىسابلىنىدۇ. يۇقىرى دەرىجىلىك يەتكۈزگۈچىلەرنىڭ يەتكۈزۈش
        ئۈنىمى تۆۋەن دەرىجىلىك يەتكۈزگۈچىلىلەرنىڭكىدىن يۇقىرى بولۇش قائىدىسىگە
        ئاساسەن، سائەت 13دىن15كىچە بولغان ۋاقىت بۆلىكىدىن باشقا ۋاقىتتا يۇقىرى
        دەرىجىلىك يەتكۈزگۈچىلەرگە ئالدىن زاكاز تەقسىملى نىدۇ. يۇلتۇز دەرىجىسى
        ئوخشاش شەرت ئاستىدا دەرىجە نومۇرى يۇقىرىدىن تۆۋەنگە قارىتا زاكاز تەقسىم
        قىلىنىلىدۇ.
      </div>
    </div>
    <div
      class="grade-rule-card grade-rule-card-zh"
      dir="ltr"
      v-if="lang === 'zh'"
    >
      <h2 class="title">配送员等级</h2>
      <div class="desc">
        配送员等级级等级积分每周一更新。
        配送员最多最多配送数根据前一天配送的订单数据统计确定，并每天早晨更新（不含迟到或后台授权完成的订单）。
        由于各区域订单及配送员数量不同的原因配送员等级平均分为1-5星级。
        计分规则：计算上一周（周一到周日）的配送订单数，最终根据配送员总分排行及分级。
      </div>
      <table class="grade-table">
        <thead>
          <tr>
            <th>类型</th>
            <th>详情</th>
            <th>分数</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>基础分数</td>
            <td>基础分数</td>
            <td class="score plus">100</td>
          </tr>
          <tr>
            <td rowspan="2">加分项</td>
            <td>按时配送</td>
            <td class="score plus">+0.2</td>
          </tr>
          <tr>
            <td>好评</td>
            <td class="score plus">+0.3</td>
          </tr>
          <tr>
            <td rowspan="6">扣分项</td>
            <td>迟到时间0-5分钟</td>
            <td class="score minus">-1</td>
          </tr>
          <tr>
            <td>迟到时间5-10分钟</td>
            <td class="score minus">-2</td>
          </tr>
          <tr>  
            <td>迟到时间10分钟以上</td>
            <td class="score minus">-3</td>
          </tr>
          <tr>
            <td>投诉</td>
            <td class="score minus">-3</td>
          </tr>
          <tr>
            <td>差评</td>
            <td class="score minus">-1</td>
          </tr>
          <tr>
            <td>预订单提前20分钟配送</td>
            <td class="score minus">-1</td>
          </tr>
        </tbody>
      </table>
      <div class="sub-title">分级订单分配规则</div>
      <div class="desc">
        记录配送员出勤打卡到分配订单的实际出勤情况和在此时间段内配送的订单总数，并通过记录计算配送员配送效率。根据高级配送员的配送效率高于低级配送员的派送效率的原则，除了每天13点至15点的时间段外，给高级配送员有限分配订单，星级相同的情况下高积分的配送员优先分配订单。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      lang: "ug",
    };
  },
  created() {
    this.lang = this.$route.query.lang || "ug";
  },
};
</script>

<style scoped>
.grade-rule-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  background: #f7f7f7;
  padding: 10px 10px;
  font-family: "UKIJEkran", sans-serif;
}
.grade-rule-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 18px 14px;
  max-width: 370px;
  width: 100%;
  font-family: "UKIJEkran", sans-serif;
}
.grade-rule-card-zh {
  direction: ltr;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}
.sub-title {
  font-size: 16x;
  font-weight: bold;
  margin: 24px 0 8px 0;
}
.desc {
  color: #444;
  font-size: 15px;
  margin-bottom: 18px;
  line-height: 1.7;
  text-align: justify;
}
.grade-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 18px;
  font-size: 15px;
}
.grade-table th,
.grade-table td {
  border: 1px solid #eee;
  padding: 6px 8px;
}
.grade-table th {
  background: #f5f5f5;
  font-weight: 600;
}
.score.plus {
  color: #1ca237;
  font-weight: bold;
  direction: ltr;
  text-align: left;
}
.score.minus {
  color: #e23c3c;
  font-weight: bold;
  direction: ltr;
  text-align: left;
}
</style>
